import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import FormItem from '../../../../common/forms/FormItem';
import { isRequired } from '../../../../../utils/validators';
import SupplierSelect from '../../../../common/forms/select/SupplierSelect';

const FORM_NAME = 'DeleteItineraryFoodForm';

const DeleteItineraryFoodForm = ({
  handleSubmit,
  handleProcess,
  onCancel,
  submitting,
}) => {
  const onSubmit = (formValues) => {
    handleProcess(formValues);
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <FormGroup row>
        <FormItem label="Proveedor" required>
          <Field
            name="supplierId"
            component={SupplierSelect}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>

      <div className="text-right mt-3">
        <Button
          type="button"
          color="secondary"
          className="mr-2"
          onClick={onCancel}
          disabled={submitting}
        >
          Cancelar
        </Button>

        <Button type="submit" color="danger" disabled={submitting}>
          <i className="fa fa-trash-o" /> Eliminar
        </Button>
      </div>
    </Form>
  );
};

DeleteItineraryFoodForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleProcess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
};

DeleteItineraryFoodForm.defaultProps = {
  submitting: false,
};

export default reduxForm({
  form: FORM_NAME,
})(DeleteItineraryFoodForm);
